<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <!-- rtu选择 -->
        <div class="label">危废名称：</div>
        <Select v-model="search.wasteTypeId" style="width: 15em" placeholder="按危废名称查询" clearable>
          <Option v-for="item in wasteTypeList" :key="item.id" :value="item.id">{{ item.wasteName }} -
            {{ item.wasteTypeName }}({{ item.wasteTypeCode }})</Option>
        </Select>
        <div class="label" style="margin-left: 10px;"> 转移时间：</div>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;"
          @on-change="dateSelect($event)"></DatePicker>
        <div class="label" style="margin-left: 10px;"> 申请状态：</div>
        <Select v-model="search.requestStatus" placeholder="按申请状态查询" clearable style="width: 10em;text-align:center;">
          <Option v-for="str in requestStatusEnum" :key="str" :value="str">{{ str }}</Option>
        </Select>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData" v-if="checkPermission('wasteRequest:create')">新建申请</i-button>
        <i-button type="error" style="margin-left: 1em;" v-if="checkPermission('wasteRequest:del')">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120"
        v-if="modal.title != '打印'">
        <FormItem label="申请部门/装置：" prop="requestName">
          <Select v-model="formValidate.requestName" placeholder="请选择申请部门/装置" :disabled="!checkPermission(['wasteRequest:create', 'wasteRequest:modify'])" clearable>
            <Option v-for="(department, index) in departmentList" :key="index" :value="department">
              {{ department }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="转移危废名称：" prop="wasteTypeId">
          <Select v-model="formValidate.wasteTypeId"
            :disabled="!checkPermission(['wasteRequest:create', 'wasteRequest:modify'])" clearable>
            <Option v-for="item in wasteTypeList" :key="item.id" :value="item.id">{{ item.wasteName }} - {{
              item.wasteTypeName }}({{ item.wasteTypeCode }})</Option>
          </Select>
        </FormItem>
        <FormItem label="转移时间：" prop="transferDate">
          <DatePicker type="date" placeholder="选择转移时间" v-model="formValidate.transferDate"
            :disabled="!checkPermission(['wasteRequest:create', 'wasteRequest:modify'])"></DatePicker>
        </FormItem>
        <FormItem label="转移情况说明：" prop="transferAmount">
          <i-input v-model="formValidate.transferAmount" type="textarea" :rows="2" placeholder="注明转移量"
            :disabled="!checkPermission(['wasteRequest:create', 'wasteRequest:modify'])"></i-input>
        </FormItem>
        <FormItem label="备注：" prop="notes">
          <i-input v-model="formValidate.notes" type="textarea" :rows="2" placeholder="请输入备注"
            :disabled="!checkPermission(['wasteRequest:create', 'wasteRequest:modify'])"></i-input>
        </FormItem>
        <div style="background-color: #2db7f5;" v-show="modal.title == '审批' || modal.title == '接收'">
          <FormItem label="审批意见：" prop="approverNotes">
            <i-input v-model="formValidate.approverNotes" type="textarea" :rows="2" placeholder="请输入审批意见"
              :disabled="!checkPermission('wasteRequest:approve')"></i-input>
          </FormItem>
        </div>
        <div style="background-color: #19be6b;" v-show="modal.title == '接收'">
          <FormItem label="接收说明：" prop="recipientNotes">
            <i-input v-model="formValidate.recipientNotes" type="textarea" :rows="2" placeholder="请输入接收说明"
              :disabled="!checkPermission('wasteRequest:recipient')"></i-input>
          </FormItem>
        </div>
      </Form>

      <div ref="printDiv" v-if="modal.title == '打印'">
        <h1 style="text-align: center;">危险废物（入库）转移申请表</h1>
        <table
          style="border-collapse: collapse; font-family: Arial, sans-serif; width: 100%; max-width: 800px; margin: 20px auto; border-top: 1px solid #ddd; border-right: 1px solid #ddd;">
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              申请部门/装置</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{
              this.showprint.requestName }}</td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              申请日期</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{
              this.gettimeStamp(this.showprint.createDate, "yyyy-MM-dd HH:mm:ss") }}</td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              转移危废名称</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{
              this.showprint.wasteName }}</td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              危废代码</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{
              this.showprint.wasteTypeNameCode }}</td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              转移时间</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{
              this.gettimeStamp(this.showprint.transferDate, "yyyy-MM-dd") }}</td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              转移情况说明<br />（注明转移量）</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{
              this.showprint.transferAmount }}</td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              备注</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{
              this.showprint.notes }}</td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              申请人</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">{{
              this.showprint.applicantUserName }} </td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              审批</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">
              <div style="font-weight: bold;">{{ this.showprint.approverNotes }} </div>
              <div style="text-align: right;">{{ this.showprint.approverUserName }}<br />
                {{ this.gettimeStamp(this.showprint.approverDate, "yyyy-MM-dd HH:mm:ss") }}</div>
            </td>
          </tr>
          <tr>
            <td
              style="padding: 15px; text-align: right; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; width: 130px;">
              接收</td>
            <td style="padding: 15px; text-align: left; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd;">
              <div style="font-weight: bold;">{{ this.showprint.recipientNotes }} </div>
              <div style="text-align: right;">{{ this.showprint.recipientUserName }}<br />
                {{ this.gettimeStamp(this.showprint.recipientDate, "yyyy-MM-dd HH:mm:ss") }}</div>
            </td>
          </tr>
        </table>
      </div>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}

.styled-table {
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  width: 100%;
  max-width: 800px;
  margin: 20px auto;
  border-top: 1px solid #ddd;
  border-right: 1px solid #ddd;
}

.styled-table tr td {
  padding: 15px;
  text-align: left;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.styled-table tr td:first-child {
  width: 130px;
  text-align: right;
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import printJS from 'print-js';

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "申请状态",
            key: "requestStatus",
            align: "center"
          },
          {
            title: "申请部门/装置",
            key: "requestName",
            align: "center"
          },
          {
            title: "转移危废名称",
            key: "wasteName",
            width: 160,
            align: "center"
          },
          {
            title: "危废代码",
            key: "wasteTypeNameCode",
            align: "center"
          },
          {
            title: "转移时间",
            key: "transferDate",
            align: "center",
            render(h, params) {
              return h(
                "span",
                {},
                timeStamp(params.row.transferDate, "yyyy-MM-dd")
              );
            }
          },
          {
            title: "备注信息",
            key: "notes",
            align: "center"
          },
          {
            title: "申请日期",
            key: "createDate",
            align: "center",
            render(h, params) {
              return h(
                "span",
                {},
                timeStamp(params.row.createDate, "yyyy-MM-dd HH:mm:ss")
              );
            }
          },
          {
            title: "操作",
            align: "center",
            width: 300,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "default",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "打印";
                        this.modal.show = true;
                        this.showprint = params.row;
                      }
                    }
                  },
                  "打印"
                ), h(
                  "i-button",
                  {
                    props: {
                      type: "info",
                      size: "small",
                      disabled: !this.checkPermission("wasteRequest:approve")
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "审批";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          requestName: params.row.requestName, // 申请部门/装置
                          wasteTypeId: params.row.wasteTypeId, // 危废信息ID
                          transferAmount: params.row.transferAmount, // 转移情况说明
                          transferDate: timeStamp(params.row.transferDate, "yyyy-MM-dd", true), // 转移时间
                          notes: params.row.notes, // 备注信息
                          approverNotes: params.row.approverNotes // 审批意见
                        };
                      }
                    }
                  },
                  "审批"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "success",
                      size: "small",
                      disabled: !this.checkPermission("wasteRequest:recipient")
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "接收";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          requestName: params.row.requestName, // 申请部门/装置
                          wasteTypeId: params.row.wasteTypeId, // 危废信息ID
                          transferAmount: params.row.transferAmount, // 转移情况说明
                          transferDate: timeStamp(params.row.transferDate, "yyyy-MM-dd", true), // 转移时间
                          notes: params.row.notes, // 备注信息
                          approverNotes: params.row.approverNotes, // 审批意见
                          recipientNotes: params.row.recipientNotes // 接收说明
                        };
                      }
                    }
                  },
                  "接收"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small",
                      disabled: !this.checkPermission("wasteRequest:modify")
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          requestName: params.row.requestName, // 申请部门/装置
                          wasteTypeId: params.row.wasteTypeId, // 危废信息ID
                          transferAmount: params.row.transferAmount, // 转移情况说明
                          transferDate: timeStamp(params.row.transferDate, "yyyy-MM-dd", true), // 转移时间
                          notes: params.row.notes // 备注信息
                        };
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                      disabled: !this.checkPermission("wasteRequest:del")
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        wasteTypeId: null,
        startDate: null,
        endDate: null,
        requestStatus: null
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "新建申请",
        companyShow: false // 站点工艺图modal显示隐藏
      },
      // 表单数据
      formValidate: {
        requestName: "", // 申请部门/装置
        wasteTypeId: "", // 危废信息ID
        transferAmount: "", // 转移情况说明
        transferDate: new Date(), // 转移时间
        notes: "" // 备注信息
      },
      // 验证
      ruleValidate: {
        requestName: [{ required: true, message: "不能为空", trigger: "blur" }],
        wasteTypeId: [{ required: true, message: "请选择", trigger: "change", type: 'number' }],
        transferAmount: [{ required: true, message: "不能为空", trigger: "blur" }],
        transferDate: [{ required: true, type: "date", message: "不能为空" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      wasteTypeList: [], // 设备类型枚举
      wasteUserRoles: [], // 当前用户拥有的权限
      requestStatusEnum: ['待审批', '已审批', '已接收'],
      departmentList: [
        "热交换器车间",
        "两器车间",
        "铜管车间",
        "毛细管车间",
        "铝管车间",
        "双层管车间"
      ],
      showprint: null,
    };
  },
  components: {
    toolbar
  },
  created() {
    this.getData(); // 数据初始化
    this.getWasteType();
    this.getWasteRequestUserRole();
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "新建申请";
      this.modal.show = true;
      this.formValidate = {
        requestName: "", // 申请部门/装置
        wasteTypeId: "", // 危废信息ID
        transferAmount: "", // 转移情况说明
        transferDate: new Date(), // 转移时间
        notes: "", // 备注信息
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Waste.getWasteRequestList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Waste.getWasteRequestDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      console.log(this.formValidate); // 检查 transferDate 的格式
      //增、改操作
      if (this.modal.title == "打印") {
        printJS({
          printable: this.$refs.printDiv.innerHTML,
          type: 'raw-html',
        });
        return;
      }
      //console.log(this.formValidate)
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "新建申请") {
            this.$api.Waste.postWasteRequestAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "新建申请成功",
                  desc: "新建申请成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "新建申请失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else if (this.modal.title == "更新") {
            this.$api.Waste.postWasteRequestEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else if (this.modal.title == "审批") {
            this.$api.Waste.postWasteRequestApprove({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else if (this.modal.title == "接收") {
            this.$api.Waste.postWasteRequestRecipient({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$Notice.warning({
              title: "系统故障(0x215E1)",
              desc: res.message || "请联系管理员"
            });
          }
        }
      });
    },
    // 获取危废类型
    getWasteType() {
      this.$api.Waste.getWasteTypeAll({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.wasteTypeList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取危废类型失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取用户入库申请角色权限
    getWasteRequestUserRole() {
      this.$api.Waste.getWasteRequestUserRole({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.wasteUserRoles = res.data;
        } else {
          this.$Notice.warning({
            title: "获取权限失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    checkPermission(permission) {
      if (Array.isArray(permission)) {
        return permission.some(p => this.wasteUserRoles.includes(p));
      } else {
        return this.wasteUserRoles.includes(permission);
      }
    },
    findWasteById(id) {
      const wastes = this.wasteTypeList;
      for (let i = 0; i < wastes.length; i++) {
        if (wastes[i].id === id) {
          return wastes[i];
        }
      }

      return null;
    },
    gettimeStamp(d, f) {
      return timeStamp(d, f);
    },
    // dateSelect(date) {
    //   this.search.startDate = new Date(date[0]).setHours("0");
    //   this.search.endDate = new Date(date[1]).setHours("24");
    // },
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours(0, 0, 0, 0);
      this.search.endDate = new Date(date[1]).setHours(23, 59, 59, 999);
    },
  }
};
</script>